import React, { useRef } from "react";
import AsyncSelect from "react-select/async";
import { getExistingCustomer } from "adminApi/RoomBookingApi/RoomBooking";

const DynamicAsyncSelect = ({
    onChange,
    placeholder = "Enter number...",
    isDisabled = false,
    defaultValue = null,
}) => {
    const debounceRef = useRef(null);
    const loadOptions = (inputValue) => {
        if (!inputValue) return Promise.resolve([]);
        if (debounceRef.current) clearTimeout(debounceRef.current);
        return new Promise((resolve) => {
            debounceRef.current = setTimeout(async () => {
                try {
                    const response = await getExistingCustomer(inputValue);
                    const data = response.data?.data || response.data || [];

                    const options = data.map((item) => ({
                        label: `${item.name} (${item.full_name})`,
                        value: item.customer_id,
                        fullData: item,
                    }));

                    resolve(options);
                } catch (err) {
                    console.error("Customer search error:", err);
                    resolve([]);
                }
            }, 300);
        });
    };

    return (
        <AsyncSelect
            cacheOptions
            defaultOptions
            loadOptions={loadOptions}
            onChange={(selected) => onChange(selected)}
            placeholder={placeholder}
            isDisabled={isDisabled}
            defaultValue={defaultValue}
        />
    );
};

export default DynamicAsyncSelect;
